// websocketHandler.js

import { updateIvData, updateEvData, updateJbMrtData, updateJkVbV1Data, updateAcbData, updateDashboardData, updateRelayData } from '../store'; // Redux 스토어에서 updateIvData 액션을 임포트

export const handleRealTimeDataIv = (message, dispatch) => {
  try {
    // WebSocket에서 받은 데이터를 파싱
    const data = JSON.parse(message);

    // console.log("받은 데이터", data)

    // 데이터 처리 및 상태 업데이트
    Object.keys(data).forEach((seq) => {
      const entry = data[seq];

      if (entry && entry.sendCount !== undefined && entry.receiveCount !== undefined) {
        // Redux 상태 업데이트
        dispatch(updateIvData({
          seq: Number(seq),  // seq 값을 숫자로 변환하여 전달
          PvTotalVolt: entry?.PvTotalVolt ?? 0,
          PvTotalCurrent: entry?.PvTotalCurrent ?? 0,
          PvPower: entry?.PvPower ?? 0,
          PvChVolt: Array.isArray(entry?.PvChVolt) && entry.PvChVolt.length === 30 ? entry.PvChVolt : Array(30).fill(0),
          PvCurrent: Array.isArray(entry?.PvCurrent) && entry.PvCurrent.length === 30 ? entry.PvCurrent : Array(30).fill(0),
          Grid_RS_Volt: entry?.Grid_RS_Volt ?? 0,
          Grid_ST_Volt: entry?.Grid_ST_Volt ?? 0,
          Grid_TR_Volt: entry?.Grid_TR_Volt ?? 0,
          Grid_R_Current: entry?.Grid_R_Current ?? 0,
          Grid_S_Current: entry?.Grid_S_Current ?? 0,
          Grid_T_Current: entry?.Grid_T_Current ?? 0,
          mode: entry?.mode ?? 0,
          Pfault: entry?.Pfault ?? 0,
          Warn: entry?.Warn ?? 0,
          fault0: entry?.fault0 ?? 0,
          fault1: entry?.fault1 ?? 0,
          fault2: entry?.fault2 ?? 0,
          fault3: entry?.fault3 ?? 0,
          fault4: entry?.fault4 ?? 0,
          Grid_Power: entry?.Grid_Power ?? 0,
          Grid_Factor: entry?.Grid_Factor ?? 0,
          Grid_Frq: entry?.Grid_Frq ?? 0,
          Add_power: entry?.Add_power_view ?? entry?.Add_power ?? 0,
          Process_Add_power: entry?.Process_Add_power ?? 0,
          // 백엔드 RegisterIvPublic은 Temp 필드명 사용 (Huawei 등)
          temperature: entry?.temperature ?? entry?.Temp ?? 0,
          state: entry?.state ?? 0,
          Error: Array.isArray(entry?.Error) ? entry.Error : [0],
          sendCount: entry?.sendCount ?? 0,
          receiveCount: entry?.receiveCount ?? 0,
          Mppt_Volt: Array.isArray(entry?.Mppt_Volt) && entry.Mppt_Volt.length === 15 ? entry.Mppt_Volt : Array(15).fill(0),
          Mppt_Current: Array.isArray(entry?.Mppt_Current) && entry.Mppt_Current.length === 15 ? entry.Mppt_Current : Array(15).fill(0),
          todayAdd: entry?.todayAdd ?? 0,
          thisMonthAdd: entry?.thisMonthAdd ?? 0,
          thisYearAdd: entry?.thisYearAdd ?? 0,
          schedule: entry?.schedule ?? 0,
        }));
      } else {
        console.error(`Invalid data for Ivseq ${seq}`);
      }
    });
  } catch (error) {
    console.error('Error parsing WebSocket Ivdata:', error);
  }
};




export const handleRealTimeDataEv = (message, dispatch) => {
  try {
    // WebSocket에서 받은 데이터를 파싱
    const data = JSON.parse(message);

    // 데이터 처리 및 상태 업데이트
    Object.keys(data).forEach((seq) => {
      const entry = data[seq];

      if (entry && entry.sendCount !== undefined && entry.receiveCount !== undefined) {
        // Redux 상태 업데이트
        dispatch(updateEvData({
          seq: Number(seq),  // seq 값을 숫자로 변환하여 전달
          sun: entry?.sun ?? 0,
          temperature: entry?.temperature ?? 0,
          state: entry?.state ?? 0,
          Error: Array.isArray(entry?.Error) ? entry.Error : [0],
          sendCount: entry?.sendCount ?? 0,
          receiveCount: entry?.receiveCount ?? 0,
          todayAdd: entry?.todayAdd ?? 0,
          thisMonthAdd: entry?.thisMonthAdd ?? 0,
          thisYearAdd: entry?.thisYearAdd ?? 0,
          // WH-2300S 확장 필드
          family_code: entry?.family_code ?? 0,
          security_code: entry?.security_code ?? 0,
          fix: entry?.fix ?? 0,
          low_battery: entry?.low_battery ?? false,
          wind_direction: entry?.wind_direction ?? 0,
          wind_direction_raw: entry?.wind_direction_raw ?? 0,
          wind_speed: entry?.wind_speed ?? 0,
          wind_speed_mps: entry?.wind_speed_mps ?? 0,
          wind_speed_raw: entry?.wind_speed_raw ?? 0,
          gust_speed: entry?.gust_speed ?? 0,
          gust_speed_mps: entry?.gust_speed_mps ?? 0,
          gust_speed_raw: entry?.gust_speed_raw ?? 0,
          temperature_raw: entry?.temperature_raw ?? 0,
          humidity: entry?.humidity ?? 0,
          humidity_raw: entry?.humidity_raw ?? 0,
          rain_counter: entry?.rain_counter ?? 0,
          rainfall: entry?.rainfall ?? 0,
          rainfall_mm: entry?.rainfall_mm ?? 0,
          uv_index: entry?.uv_index ?? 0,
          uv_raw: entry?.uv_raw ?? 0,
          light: entry?.light ?? 0,
          light_lux: entry?.light_lux ?? 0,
          light_raw: entry?.light_raw ?? 0,
          received_crc: entry?.received_crc ?? 0,
          calculated_crc: entry?.calculated_crc ?? 0,
        }));
      } else {
        console.error(`Invalid data for Ivseq ${seq}`);
      }
    });
  } catch (error) {
    console.error('Error parsing WebSocket Ivdata:', error);
  }
};


export const handleRealTimeDataJbMrt = (message, dispatch) => {
  try {
    // WebSocket에서 받은 데이터를 파싱
    const data = JSON.parse(message);

    // 데이터 처리 및 상태 업데이트
    Object.keys(data).forEach((seq) => {
      const entry = data[seq];

      if (entry && entry.sendCount !== undefined && entry.receiveCount !== undefined) {
        // Redux 상태 업데이트
        dispatch(updateJbMrtData({

          seq: Number(seq),  // seq 값을 숫자로 변환하여 전달
          PvTotalVolt: entry?.PvTotalVolt ?? 0,
          pvTotalCurrent: entry?.pvTotalCurrent ?? 0,
          pvChVolt: Array.isArray(entry?.pvChVolt) ? entry.pvChVolt : [0],
          pvChCurrent: Array.isArray(entry?.pvChCurrent) ? entry.pvChCurrent : [0],
          temperature: entry?.temperature ?? 0,
          specialMode: Array.isArray(entry?.specialMode) ? entry.specialMode : [0],
          fire: entry?.fire ?? 0,
          // 지투파워 확장 필드
          relayStatus: Array.isArray(entry?.relayStatus) ? entry.relayStatus : [],
          arcCount: Array.isArray(entry?.arcCount) ? entry.arcCount : [],
          tevDb: entry?.tevDb ?? 0,
          tevCnt: entry?.tevCnt ?? 0,
          // 지투파워 설정값 전달
          setarcCount: entry?.setarcCount ?? 0,
          setTemp: entry?.setTemp ?? 0,
          // 한빛 확장 필드
          leakCurrent_hanbit: Array.isArray(entry?.leakCurrent_hanbit) ? entry.leakCurrent_hanbit : [],
          sendCount: entry?.sendCount ?? 0,
          receiveCount: entry?.receiveCount ?? 0,
          // 비엔엠 확장 필드
          coValue: entry?.coValue ?? 0,
          coAlarmSetting: entry?.coAlarmSetting ?? 0,
          tempAlarmSetting: entry?.tempAlarmSetting ?? 0,
          maxTemp: entry?.maxTemp ?? 0,
          leakCurrent: Array.isArray(entry?.leakCurrent) ? entry.leakCurrent : [],
          leakSetting: Array.isArray(entry?.leakSetting) ? entry.leakSetting : [],

        }));
      } else {
        console.error(`Invalid data for Ivseq ${seq}`);
      }
    });
  } catch (error) {
    console.error('Error parsing WebSocket Ivdata:', error);
  }
};




export const handleRealTimeDataJkVbV1 = (message, dispatch) => {
  try {
    const data = JSON.parse(message);
    const seqCount = Object.keys(data).length; // seq의 개수를 동적으로 파악

    Object.keys(data).forEach((seq) => {
      const entry = data[seq];

      if (entry && entry.sendCount !== undefined && entry.receiveCount !== undefined) {
        dispatch(updateJkVbV1Data({
          seq: Number(seq),
          Id: entry?.Id ?? 0,
          // seq 개수만큼 배열 크기 설정
          Ax: Array.isArray(entry?.Ax) ? entry.Ax : Array(seqCount).fill(0),
          Ay: Array.isArray(entry?.Ay) ? entry.Ay : Array(seqCount).fill(0),
          Az: Array.isArray(entry?.Az) ? entry.Az : Array(seqCount).fill(0),
          Yx: Array.isArray(entry?.Yx) ? entry.Yx : Array(seqCount).fill(0),
          Yy: Array.isArray(entry?.Yy) ? entry.Yy : Array(seqCount).fill(0),
          Yz: Array.isArray(entry?.Yz) ? entry.Yz : Array(seqCount).fill(0),
          Vibration: Array.isArray(entry?.Vibration) ? entry.Vibration : Array(seqCount).fill(0),
          ZeroAx: Array.isArray(entry?.ZeroAx) ? entry.ZeroAx : Array(seqCount).fill(0),
          ZeroAy: Array.isArray(entry?.ZeroAy) ? entry.ZeroAy : Array(seqCount).fill(0),
          ZeroAz: Array.isArray(entry?.ZeroAz) ? entry.ZeroAz : Array(seqCount).fill(0),
          ZeroYx: Array.isArray(entry?.ZeroYx) ? entry.ZeroYx : Array(seqCount).fill(0),
          ZeroYy: Array.isArray(entry?.ZeroYy) ? entry.ZeroYy : Array(seqCount).fill(0),
          ZeroYz: Array.isArray(entry?.ZeroYz) ? entry.ZeroYz : Array(seqCount).fill(0),
        }));
      } else {
        console.error(`Invalid data for seq ${seq}`);
      }
    });
  } catch (error) {
    console.error('Error parsing WebSocket JkVbV1 data:', error);
  }
};


// ACB 실시간 데이터 핸들러
export const handleRealTimeDataAcb = (message, dispatch) => {
  try {
    const data = JSON.parse(message);


    Object.keys(data).forEach((seq) => {
      const entry = data[seq] || {};

      if (entry && entry.sendCount !== undefined && entry.receiveCount !== undefined) {
        dispatch(updateAcbData({
          seq: Number(seq),                     // seq 숫자화
          voltage: entry?.voltage ?? 0,
          current: entry?.current ?? 0,
          power: entry?.power ?? 0,
          Add_power: entry?.Add_power ?? 0,
          add_power1: entry?.add_power1 ?? 0,
          add_power2: entry?.add_power2 ?? 0,
          add_power3: entry?.add_power3 ?? 0,
          sendCount: entry?.sendCount ?? 0,
          receiveCount: entry?.receiveCount ?? 0,
          last_receive_time: entry?.last_receive_time ?? 0, // 백엔드 값 그대로
        }));
      } else {
        console.error(`Invalid data for ACB seq ${seq}`, entry);
      }
    });
  } catch (error) {
    console.error('Error parsing WebSocket ACB data:', error);
  }
};


export const handleRealTimeDataRelay = (message, dispatch) => {
  try {
    const data = JSON.parse(message);

    Object.keys(data).forEach((seq) => {
      const entry = data[seq] || {};

      if (entry && entry.sendCount !== undefined && entry.receiveCount !== undefined) {
        dispatch(updateRelayData({
          seq: Number(seq),
          relayStatus: Array.isArray(entry?.relayStatus) ? entry.relayStatus : [0, 0, 0, 0],
          ch1_on: entry?.ch1_on ?? 1,
          ch1_off: entry?.ch1_off ?? 1,
          ch2_on: entry?.ch2_on ?? 50,
          ch2_off: entry?.ch2_off ?? 50,
          ch3_on: entry?.ch3_on ?? 1000,
          ch3_off: entry?.ch3_off ?? 1000,
          ch4_on: entry?.ch4_on ?? 0,
          ch4_off: entry?.ch4_off ?? 0,
          sendCount: entry?.sendCount ?? 0,
          receiveCount: entry?.receiveCount ?? 0,
          last_receive_time: entry?.last_receive_time ?? 0,
          state: entry?.state ?? 0,
        }));
      } else {
        console.error(`Invalid data for Relay seq ${seq}`, entry);
      }
    });
  } catch (error) {
    console.error('Error parsing WebSocket Relay data:', error);
  }
};


// Dashboard 실시간 데이터 핸들러 (payload: { 40: {sendCount, receiveCount}, ... })
export const handleRealTimeDataDashboard = (message, dispatch) => {
  // console.log("message", message)
  try {
    // payload가 문자열이면 파싱, 객체면 그대로 사용
    const data = (typeof message === 'string') ? JSON.parse(message) : message;

    if (!data || typeof data !== 'object') {
      console.error('[WS] Dashboard payload is not an object:', data);
      return;
    }

    Object.entries(data).forEach(([seqKey, entry]) => {
      if (!entry) return;

      const seq  = Number(seqKey);                          // "40" → 40
      const send = Number(entry.sendCount ?? 0);
      const recv = Number(entry.receiveCount ?? 0);

      if (!Number.isFinite(seq)) {
        console.error('[WS] Invalid seq key:', seqKey, entry);
        return;
      }

      // 디버깅 로그
      // console.log(`[WS] dashboard seq=${seq} send=${send} recv=${recv}`);

      dispatch(updateDashboardData({
        seq,
        sendCount: send,
        receiveCount: recv,
      }));
    });
  } catch (error) {
    console.error('Error parsing WebSocket Dashboard data:', error, message);
  }
};